
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#ef5350","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","data-name":"vuesax/twotone/pause"}},[_c('path',{attrs:{"d":"M17.75 31.85V8.15C17.75 5.9 16.8 5 14.4 5H8.35C5.95 5 5 5.9 5 8.15v23.7C5 34.1 5.95 35 8.35 35h6.05c2.4 0 3.35-.9 3.35-3.15z","opacity":".4"}}),_c('path',{attrs:{"data-name":"Vector","d":"M35 31.85V8.15C35 5.9 34.05 5 31.65 5H25.6c-2.383 0-3.35.9-3.35 3.15v23.7c0 2.25.95 3.15 3.35 3.15h6.05c2.4 0 3.35-.9 3.35-3.15z"}})])])
          )
        }
      }
    